import { render } from "./formal_document_template_data_table_editor_view.html?vue&type=template&id=5b931111&scoped=true&external"
import script from "./formal_document_template_data_table_editor.js?vue&type=script&lang=js&external"
export * from "./formal_document_template_data_table_editor.js?vue&type=script&lang=js&external"

import "./FormalDocumentTemplateDataTableEditor.vue?vue&type=style&index=0&id=5b931111&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b931111"]])

export default __exports__